// Mirrors PAYOUT_SPLITS in /app/backend/utils/scoring.py. Keep these in sync.
// These are the straight-split percentages used on the printed payout sheet,
// which assumes NO ties and every place filled — i.e. the theoretical posted
// payout the producer would print and hang at the announcer's booth.
export const PAYOUT_SPLITS = {
  1: [1.00],
  2: [0.60, 0.40],
  3: [0.50, 0.30, 0.20],
  4: [0.40, 0.30, 0.20, 0.10],
  5: [0.30, 0.25, 0.20, 0.15, 0.10],
  6: [0.28, 0.22, 0.18, 0.14, 0.10, 0.08],
  7: [0.26, 0.20, 0.15, 0.12, 0.10, 0.09, 0.08],
  8: [0.24, 0.18, 0.15, 0.12, 0.10, 0.08, 0.07, 0.06],
  9: [0.22, 0.16, 0.14, 0.12, 0.10, 0.08, 0.07, 0.06, 0.05],
  10: [0.21, 0.16, 0.13, 0.11, 0.10, 0.08, 0.07, 0.06, 0.05, 0.03],
  11: [0.19, 0.16, 0.125, 0.10, 0.09, 0.08, 0.07, 0.06, 0.05, 0.04, 0.035],
  12: [0.19, 0.16, 0.12, 0.10, 0.09, 0.08, 0.06, 0.05, 0.045, 0.04, 0.035, 0.03],
  13: [0.19, 0.155, 0.12, 0.10, 0.08, 0.07, 0.06, 0.05, 0.045, 0.04, 0.035, 0.03, 0.025],
  14: [0.19, 0.155, 0.11, 0.09, 0.08, 0.07, 0.06, 0.05, 0.045, 0.04, 0.035, 0.03, 0.025, 0.02],
  15: [0.18, 0.15, 0.11, 0.09, 0.08, 0.07, 0.06, 0.05, 0.045, 0.04, 0.035, 0.03, 0.025, 0.02, 0.015],
};

const PLACE_SUFFIX = (n) => {
  if (n >= 11 && n <= 13) return `${n}th`;
  const last = n % 10;
  return `${n}${last === 1 ? 'st' : last === 2 ? 'nd' : last === 3 ? 'rd' : 'th'}`;
};

/**
 * Build a "theoretical posted payout" breakdown for one pool — no ties, every
 * place filled. Returns an array of {place, percentage, amount}.
 */
export function buildTheoreticalPayout(placesPaid, pool) {
  const places = Math.max(1, Math.min(15, placesPaid || 1));
  const splits = PAYOUT_SPLITS[places] || [];
  return splits.map((pct, i) => ({
    place: i + 1,
    placeLabel: PLACE_SUFFIX(i + 1),
    percentage: Math.round(pct * 10000) / 100,
    amount: Math.round(pool * pct),
  }));
}
